const template = document.createElement("template");
template.innerHTML = `
<style>
  :host {
    display: block;
    font-family: var(--ctl-font-sans, system-ui, -apple-system, Segoe UI, Roboto, Arial);
    color: var(--ctl-color-text);
    min-width: 0;
    box-sizing: border-box;
  }

  .panel {
    border-radius: var(--ctl-radius-lg);
    background: var(--ctl-color-surface);
    border: 1px solid var(--ctl-color-border);
    overflow: hidden;
    min-width: 0;
    transition: box-shadow var(--ctl-transition-fast), border-color var(--ctl-transition-fast);
  }

  :host([elevated]) .panel {
    border-color: color-mix(in srgb, var(--ctl-color-border) 60%, transparent);
    box-shadow: var(--ctl-shadow-card);
  }

  /* Padding */
  :host(:not([padding]), [padding="md"]) { --pad: var(--ctl-space-3); }
  :host([padding="none"]) { --pad: 0; }
  :host([padding="sm"])   { --pad: var(--ctl-space-2); }
  :host([padding="lg"])   { --pad: var(--ctl-space-4); }

  .header, .body {
    padding: var(--pad, var(--ctl-space-3));
  }

  .header {
    display: none;
    border-bottom: 1px solid color-mix(in srgb, var(--ctl-color-border) 80%, transparent);
    background: var(--ctl-color-surface);
  }
  :host([has-header]) .header { display: block; }
</style>

<div class="panel" part="panel">
  <header class="header" part="header"><slot name="header"></slot></header>
  <div class="body" part="body"><slot></slot></div>
</div>
`;

export class CtlPanel extends HTMLElement {
  static get observedAttributes() {
    return ["elevated", "padding"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
    this._headerSlot = this.shadowRoot.querySelector('slot[name="header"]');
    this._onHeaderSlotChange = () => this._syncHeader();
  }

  connectedCallback() {
    this._headerSlot.addEventListener("slotchange", this._onHeaderSlotChange);
    this._syncHeader();
  }

  disconnectedCallback() {
    this._headerSlot.removeEventListener("slotchange", this._onHeaderSlotChange);
  }

  attributeChangedCallback() {
    // CSS handles elevated and padding via attribute selectors
  }

  get elevated() { return this.hasAttribute("elevated"); }
  set elevated(v) { v ? this.setAttribute("elevated", "") : this.removeAttribute("elevated"); }

  get padding() { return this.getAttribute("padding") || "md"; }
  set padding(v) {
    const next = ["none", "sm", "md", "lg"].includes(v) ? v : "md";
    this.setAttribute("padding", next);
  }

  _syncHeader() {
    const hasHeader = this._headerSlot.assignedNodes({ flatten: true }).length > 0;
    hasHeader ? this.setAttribute("has-header", "") : this.removeAttribute("has-header");
  }
}

customElements.define("ctl-panel", CtlPanel);

export default CtlPanel;
